export const translatePrefix = "AddressGeneration";
